// extracted by mini-css-extract-plugin
export default {"endContainer":"src-components-Icon-Delete-css-module__endContainer--FUtRH","deleteIcon":"src-components-Icon-Delete-css-module__deleteIcon--EZYGt"};